import api from './interceptor'

export const myCarList = params => {
  return api.get('/customer/carInfo/myCarList', { params })
}

export const getCarInfoWithVin = vin => {
  return api.get(`/car/vehicle-info/${vin}`)
}

export const updateCarInfo = params => {
  return api.post('/customer/carInfo/update', params)
}
export const delCarInfo = params => {
  return api.post('/customer/carInfo/delete', params)
}
export const addCarInfo = params => {
  return api.post('/customer/carInfo/add', params)
}
export const getCarAgeByDate = params => {
  return api.get('/customer/carInfo/getCarAgeByDate', { params })
}
export const getCarInfo = params => {
  return api.get('/customer/carInfo/get', { params })
}
export const getMyDefault = params => {
  return api.get('/customer/carInfo/getMyDefault', { params })
}
export const addFromQr = params => {
  return api.post('/customer/carInfo/addFromQr', params)
}
